import * as Factory from 'factory.ts'
import faker from 'faker'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import {
  BudgetCategoryCustomFieldCondition,
  type BudgetCategoryCustomFieldConditionConstructorData,
} from './BudgetCategoryCustomFieldCondition'

export const BudgetCategoryCustomFieldConditionConstructorFactory =
  Factory.Sync.makeFactory<BudgetCategoryCustomFieldConditionConstructorData>({
    fieldId: Factory.each(() => faker.random.number()),
    values: Factory.each(() => [faker.random.word()]),
  })

export const BudgetCategoryCustomFieldConditionFactory = EntityFactory(
  BudgetCategoryCustomFieldCondition,
  BudgetCategoryCustomFieldConditionConstructorFactory
)
